<template>
  <div class="p-6">
    <h2 class="text-2xl font-semibold mb-4">Inventory List</h2>

    <div class="overflow-x-auto bg-white shadow rounded-lg">
      <table class="min-w-full divide-y divide-gray-200">
        
        <!-- Header -->
        <thead class="bg-gray-50">
          <tr>
			<th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Inventory ID</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Manufacturer</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Part Number</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Quantity</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Condition</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Record Date</th>
          </tr>
        </thead>

        <!-- Body -->
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="(item, index) in items" :key="item.inventoryId" class="hover:bg-gray-50">
			<td class="px-4 py-3 text-sm text-gray-700">{{ index + 1 }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.inventoryId }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.manufacturer }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.partNumber }}</td>
            <td class="px-4 py-3 text-sm text-gray-700 max-w-xs truncate">
              {{ item.description }}
            </td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.quantity }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.partCondition }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.price }}</td>
            <td class="px-4 py-3 text-sm text-gray-700">
              {{ formatDate(item.recordDate) }}
            </td>
          </tr>

          <tr v-if="items.length === 0">
            <td colspan="8" class="text-center py-6 text-gray-500">
              No data found
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sandbox",

  async created() {
    await this.getInventory();
  },

  data: () => ({
    items: []
  }),

  methods: {
    async getInventory() {
      try {
        const res = await this.$http.get("/api/sandbox/inventory-api");

        if (res.data.status === 200) {
          this.items = res.data.payload;
        }
      } catch (error) {
        console.error("Failed to fetch inventory:", error);
      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    }
  }
};
</script>